import { basebbsApi, bbsApi, ccApi, utilityApi } from 'yxt-biz-pc/packages/api';

export const getComment = (id, query) => {
  return bbsApi.get(`/bbsbase/stu/common/commenttargets/${id}/comments`, {
    params: query
  });
};

/**
 * 或者指定人的发言列表
 * @param id
 * @param query
 * @returns {*}
 */
export const getUserRangeComment = (id, query, data) => {
  return bbsApi.post(`/bbseng/${id}/comments/list4mine`, data, {
    params: query
  });
};

export const getReplay = (id, query) => {
  return bbsApi.get(`/bbsbase/stu/common/comment/${id}/replies`, {
    params: query
  });
};

export const createReplay = params => {
  return bbsApi.post('/bbsbase/stu/common/comments', params);
};

export const deleteComment = params => {
  return bbsApi.delete('/bbsbase/stu/admin/comments', {
    data: params
  });
};

export const praises = params => {
  return utilityApi.post('praises?usebody=true', params);
};

// 获取用户信息（社区）
export const getCcConfig = () => {
  return ccApi.get('silenceconfigs');
};

export const recordDiscussPraise = params => {
  return basebbsApi.post('stu/common/praised/comment', params);
};
